import { BsStar, BsStarFill, BsStarHalf } from "react-icons/bs";
import {
  convertHoursToDays,
  convertMinutesToHours,
} from "utils/helpers/dateTimeHelpers";

export function formatViatorDuration({
  fixedDurationInMinutes,
  variableDurationData,
}) {
  if (fixedDurationInMinutes) {
    const minutes = fixedDurationInMinutes;

    if (minutes >= 1440) {
      const hours = convertMinutesToHours(minutes).hours;
      const formattedDays = `${convertHoursToDays(hours).days} days`;

      return formattedDays;
    } else if (minutes >= 59) {
      const hours = convertMinutesToHours(minutes).hoursWithMinutes;
      const formattedHours = `${hours} hours`;

      return formattedHours;
    } else {
      const formattedMinutes = `${Math.round(fixedDurationInMinutes)} minutes`;

      return formattedMinutes;
    }
  }

  if (variableDurationData?.fromMinutes && variableDurationData?.toMinutes) {
    const fromMinutes = variableDurationData?.fromMinutes;
    const toMinutes = variableDurationData?.toMinutes;

    if (fromMinutes >= 1440) {
      const fromHours = convertMinutesToHours(fromMinutes).hours;
      const toHours = convertMinutesToHours(toMinutes).hours;

      const formattedDays = `${convertHoursToDays(fromHours).days}-${
        convertHoursToDays(toHours).days
      } days`;

      return formattedDays;
    } else if (fromMinutes >= 59 && toMinutes < 1440) {
      const formattedMinutes = `${
        convertMinutesToHours(fromMinutes).hoursWithMinutes
      } to ${convertMinutesToHours(toMinutes).hoursWithMinutes} hours`;

      return formattedMinutes;
    } else {
      const formattedMinutes = `${fromMinutes}-${toMinutes}`;

      return formattedMinutes;
    }
  }

  return null;
}

export function generateViatorProductStars(rating, productCode) {
  let starCount = {
    full: Math.round(5 - (5 - rating)) ?? null,
    halfFull: Math.round(rating) - rating > 0.25 ? 1 : (0 ?? null),
    halfEmpty: Math.round(rating) - rating < -0.25 ? 1 : (0 ?? null),
    empty: Math.round(5 - rating) ?? null,
  };

  if (starCount.halfFull) {
    starCount.full -= 1;
  }

  if (starCount.halfEmpty) {
    starCount.empty -= 1;
  }

  const stars = {
    full: [],
    halfFull: [],
    halfEmpty: [],
    empty: [],
  };

  for (let category of Object.keys(starCount)) {
    for (let i = 0; i < starCount[category]; i++) {
      const key = `star-${productCode}-${category}-${i}`;
      let starIcon = (
        <BsStarFill key={key} size={16} color="rgb(254, 209, 65)" />
      );

      if (category === "halfEmpty" || category === "halfFull") {
        starIcon = (
          <BsStarHalf
            key={`star-${productCode}-${category}-${i}`}
            size={16}
            color="rgb(254, 209, 65)"
          />
        );
      } else if (category === "empty") {
        starIcon = (
          <BsStar
            key={`star-${productCode}-${category}-${i}`}
            size={16}
            color="rgb(254, 209, 65)"
          />
        );
      }

      stars[category].push(starIcon);
    }
  }

  return stars;
}

export async function viatorFreetextSearchClient({
  searchTerm,
  currencyCode = "USD",
  count = 1,
  withDestinationInfo = false,
  withGeocodeInfo = false,
  location,
  productFilters,
  productSorting,
  destination,
}) {
  try {
    const viatorResponse = await fetch("/api/external/viator/search-freetext", {
      method: "POST",
      body: JSON.stringify({
        searchTerm,
        currencyCode,
        count,
        withDestinationInfo,
        withGeocodeInfo,
        location,
        productFilters,
        destination,
      }),
      headers: {
        "Content-Type": "application/json",
      },
    });

    const viatorResponseData = await viatorResponse.json();

    const response = viatorResponseData;

    return response;
  } catch (error) {
    console.error(error);
  }
}
